import { getUserId, getAccountId } from '@/services/methods/user'
import { RequestConfig } from '@/services/http/types'
import http from '@/services/http'

/**
 * 查询仓单成交明细
 */
export function queryWrTradeDetail(config: RequestConfig<Model.WrTradeDetailReq> = {}) {
    return http.commonRequest<Model.WrTradeDetailRsp[]>({
        url: '/WrTrade2/QueryWrTradeDetail',
        params: {
            userid: getUserId(),
            ...config.data
        },
    })
}

/**
 * 查询仓单委托单
 */
export function queryWrOrderDetail(config: RequestConfig<Model.WrOrderDetailReq> = {}) {
    return http.commonRequest<Model.WrOrderDetailRsp[]>({
        url: '/WrTrade2/QueryWrOrderDetail',
        params: {
            userid: getUserId(),
            ...config.data
        },
    })
}

/**
 * 查询我的订单-采购订单
 */
export function queryTHJPurchaseTradeDetail(config: RequestConfig<Model.THJPurchaseTradeDetailReq> = {}) {
    return http.commonRequest<Model.THJPurchaseTradeDetailRsp[]>({
        url: '/Ferroalloy/QueryTHJPurchaseTradeDetail',
        params: {
            userid: getUserId(),
            ...config.data
        },
    })
}

/**
 * 查询仓单持有记录
 */
export function queryHoldLB(config: RequestConfig<Model.HoldLBReq> = {}) {
    return http.commonRequest<Model.HoldLBRsp[]>({
        url: '/WrTrade2/QueryHoldLB',
        params: {
            accountid: getAccountId(),
            ...config.data
        },
    })
}

/**
 * 查询提货申请
 */
export function queryWrOutInApply(config: RequestConfig<Model.WrOutInApplyReq> = {}) {
    return http.commonRequest<Model.WrOutInApplyRsp[]>({
        url: '/WrTrade2/QueryWrOutInApply',
        params: {
            userid: getUserId(),
            ...config.data
        },
    })
}

/**
 * 查询我的推广-推广收益
 */
export function queryTHJPromotionIncome(config: RequestConfig<Model.THJPromotionIncomeReq> = {}) {
    return http.commonRequest<Model.THJPromotionIncomeRsp[]>({
        url: '/Ferroalloy/QueryTHJPromotionIncome',
        params: {
            userid: getUserId(),
            ...config.data
        },
    })
}

/**
 * 查询我的推广-推广收益-明细
 */
export function queryTHJPromotionIncomeDetail(config: RequestConfig<Model.THJPromotionIncomeDetailReq> = {}) {
    return http.commonRequest<Model.THJPromotionIncomeDetailRsp[]>({
        url: '/Ferroalloy/QueryTHJPromotionIncomeDetail',
        params: {
            userid: getUserId(),
            ...config.data
        },
    })
}

/**
 * 查询我的订单-转让/受让订单
 */
export function queryTHJPurchaseTransferOrder(config: RequestConfig<Model.THJPurchaseTransferOrderReq> = {}) {
    return http.commonRequest<Model.THJPurchaseTransferOrderRsp[]>({
        url: '/Ferroalloy/QueryTHJPurchaseTransferOrder',
        params: {
            userid: getUserId(),
            ...config.data
        },
    })
}

/**
 * 查询我的订单-转让/受让订单-详情
 */
export function queryTHJPurchaseTransferOrderDetail(config: RequestConfig<Model.THJPurchaseTransferOrderDetailReq> = {}) {
    return http.commonRequest<Model.THJPurchaseTransferOrderDetailRsp[]>({
        url: '/Ferroalloy/QueryTHJPurchaseTransferOrderDetail',
        params: config.data,
    })
}

/**
 * 历史成交单查询（合约市场）
 */
export function queryHisTradeDetail(config: RequestConfig<Model.HisTradeDetailReq> = {}) {
    return http.commonRequest<Model.HisTradeDetailRsp[]>({
        url: '/Order/QueryHisTradeDetail',
        params: {
            accountID: getAccountId(),
            ...config.data
        },
    })
}

/**
 * 历史委托单查询请求（合约市场）
 */
export function queryHisTradeOrderDetail(config: RequestConfig<Model.HisTradeOrderDetailReq> = {}) {
    return http.commonRequest<Model.HisTradeOrderDetailRsp[]>({
        url: '/Order/QueryHisTradeOrderDetail',
        params: {
            accountID: getAccountId(),
            ...config.data
        },
    })
}

/**
 * 成交单查询（合约市场）
 */
export function queryTradeDetail(config: RequestConfig<Model.TradeDetailReq> = {}) {
    return http.commonRequest<Model.TradeDetailRsp[]>({
        url: '/Order/QueryTradeDetail',
        params: {
            accountID: getAccountId(),
            ...config.data
        },
    })
}

/**
 * 查询持仓明细
 */
export function queryTradeHolderDetail(config: RequestConfig<Model.TradeHolderDetailReq> = {}) {
    return http.commonRequest<Model.TradeHolderDetailRsp[]>({
        url: '/Order/QueryTradeHolderDetail',
        params: {
            userid: getUserId(),
            accids: getAccountId().toString(),
            ...config.data
        },
    })
}

/**
 * 委托单查询请求（合约市场）
 */
export function queryTradeOrderDetail(config: RequestConfig<Model.TradeOrderDetailReq> = {}) {
    return http.commonRequest<Model.TradeOrderDetailRsp[]>({
        url: '/Order/QueryTradeOrderDetail',
        params: {
            accountID: getAccountId(),
            ...config.data
        },
    })
}

/**
 * 持仓汇总查询（合约市场）
 */
export function queryTradePosition(config: RequestConfig<Model.TradePositionReq> = {}) {
    return http.commonRequest<Model.TradePositionRsp[]>({
        url: '/Order/QueryTradePosition',
        params: {
            accountID: getAccountId(),
            ...config.data
        },
    })
}

/**
 * 获取我的订单列表（水贝亿爵）
 * @param config 
 * @returns 
 */
export function querySBYJMyOrders(config: RequestConfig<Model.SBYJMyOrderReq> = {}) {
    return http.commonRequest<Model.SBYJMyOrderRsp[]>({
        url: '/sbyj/GetMyOrders',
        params: {
            userId: getUserId(),
            ...config.data
        },
    })
}

/**
 * 查询我的订单
 * @param config 
 * @returns 
 */
export function queryTradeHolderDetailEx(config: RequestConfig<Model.TradeHolderDetailExReq> = {}) {
    return http.commonRequest<Model.TradeHolderDetailExRsp[]>({
        url: '/sbyj/QueryTradeHolderDetailEx',
        params: {
            accountid: getAccountId(),
            ...config.data
        },
    })
}

/**
 * 查询我的交收（水贝亿爵）
 */
export function queryMyTradeGoodsDeliveryOfflines(config: RequestConfig<Model.MyTradeGoodsDeliveryOfflineReq> = {}) {
    return http.commonRequest<Model.MyTradeGoodsDeliveryOfflineRsp[]>({
        url: '/sbyj/QueryMyTradegoodsdeliveryoffline',
        params: {
            userid: getUserId(),
            ...config.data
        },
    })
}

/**
 * 查询我的交收-订单明细（水贝亿爵）
 */
export function queryMyDeliveryofflinedetails(config: RequestConfig<Model.MyDeliveryOfflineDetailReq> = {}) {
    return http.commonRequest<Model.MyDeliveryofflinedetailRsp[]>({
        url: '/sbyj/QueryMyDeliveryofflinedetail',
        params: {
            userid: getUserId(),
            ...config.data
        },
    })
}

/**
 * 查询我的交收-操作流水（水贝亿爵）
 */
export function queryMyDeliveryOfflineOperateLogs(config: RequestConfig<Model.MyDeliveryOfflineOperateLogReq> = {}) {
    return http.commonRequest<Model.MyDeliveryOfflineOperateLogRsp[]>({
        url: '/sbyj/QueryMyDeliveryofflineoperatelog',
        params: {
            ...config.data
        },
    })
}

/**
 * 查询我的终止订单
 * @param config 
 * @returns 
 */
export function queryTradeCloseDetails(config: RequestConfig<Model.TradeCloseDetailsReq> = {}) {
    return http.commonRequest<Model.TradeCloseDetailsRsp[]>({
        url: '/sbyj/QueryTradeCloseDetails',
        params: {
            accountid: getAccountId(),
            ...config.data
        },
    })
}

/**
 * 查询所属会员的支付信息（订单系统）
 */
export function queryMemberPayInfos(config: RequestConfig<Model.MemberPayInfosReq> = {}) {
    return http.commonRequest<Model.MemberPayInfosRsp[]>({
        url: '/sbyj/QueryMemberPayInfos',
        params: {
            userid: getUserId(),
            ...config.data
        },
    })
}

/**
 * 查询交易用户个性化设置（订单系统）
 */
export function queryUserTradeSettings(config: RequestConfig<Model.UserTradeSettingsReq> = {}) {
    return http.commonRequest<Model.UserTradeSettingsRsp[]>({
        url: '/sbyj/QueryUserTradeSettings',
        params: {
            userid: getUserId(),
            ...config.data
        },
    })
}

/**
 * 用户库存查询（订单系统）
 */
export function queryUserGoodsInventory(config: RequestConfig<Model.UserGoodsInventoryReq> = {}) {
    return http.commonRequest<Model.UserGoodsInventoryRsp[]>({
        url: '/sbyj/QueryUserGoodsInventory',
        params: {
            userId: getUserId(),
            ...config.data
        },
    })
}

/**
 *用户出入库流水（订单系统）
 */
export function queryUserGoodsInventoryLog(config: RequestConfig<Model.UserGoodsInventoryLogReq> = {}) {
    return http.commonRequest<Model.UserGoodsInventoryLogRsp[]>({
        url: '/sbyj/QueryUserGoodsInventoryLog',
        params: {
            userId: getUserId(),
            ...config.data
        },
    })
}